module.exports = __webpack_public_path__ + "public/Icons/logout.svg?ce5717d6";